module.exports = new __parcel__URL__("floor-tom_3.49806c39.mp3").toString();